// extracted by mini-css-extract-plugin
export default {"container":"FooterButtonReviewCampaign_container__psEHo"};